import React, { Component } from 'react';
import PageHeader from './PageHeader';
import HorizontalBars from '../charts/HorizontalBars';
import RowTitle from '../charts/RowTitle';
import Reflection from './Reflection';
import ComparisonKey from './ComparisonKey';
import ReviewerTypeKeys from './ReviewerTypeKeys';

export default class RankedCompetencies extends Component {
  constructor(props) {
    super(props);

    this.state = {
      limits: [{lowerLimit: 0, upperLimit: this.props.answerKeys.length}]
    };
  }

  componentDidMount() {
    const { answerKeys, reviewerAnswersAverage, revieweeAnswersAverage, reportType} = this.props;
    let sortValues;
    if (reportType === 'Self') {
      sortValues = revieweeAnswersAverage;
    } else {
      sortValues = reviewerAnswersAverage;
    }
    const sortedAnswerKeys = answerKeys.sort((a,b) => sortValues[b] - sortValues[a])
    this.setState({
      sortedAnswerKeys,
    })
  }

  componentDidUpdate(prevProps, prevState) {
    // when pdf export is requested, an initial re-render alters the page width to match the pdf, then calculates page break limits and re-renders back to normal width
    if (prevProps.layoutMode !== this.props.layoutMode) {
      if (this.props.layoutMode === 'pdfRecalculate') {
        const { sortedAnswerKeys } = this.state;
        let count = 0;
        let limits = [];
        let lowerLimit = 0;
        let upperLimit;
        let spaceAvailable = 485;
        sortedAnswerKeys.forEach((sectionID, i) => {
          // get row height and check if it will fit, if not update limits and reset count
          let rowHeight = 0;
          if (this[`competencyRow-${sectionID}`]) {
            rowHeight = this[`competencyRow-${sectionID}`].offsetHeight + 1;
          }
          if ((count + rowHeight) < spaceAvailable) {
            count += rowHeight;
          } else {
            upperLimit = i;
            limits.push({lowerLimit, upperLimit});
            lowerLimit = i;
            count = rowHeight;
            // accounts for intro text on first page by increasing spaceAvailable value
            spaceAvailable = 530;
          }
        })
        limits.push({lowerLimit, upperLimit: sortedAnswerKeys.length});
        this.setState({ limits });
        this.props.updateRankedCompetenciesPDFExportPreRenderStatus();
      }
    }
  }

  render() {
    const { reportType, generateGraph, reviewerAnswersAverage, previousReviewerAverages, sectionDetails, revieweeAnswersAverage, previousRevieweeAverages, layoutMode } = this.props;
    const { sortedAnswerKeys, limits } = this.state;
    const userColour = '#0051ff';
    const reviewerColour = '#F563B9';
    let reviewerTypes = reportType === 'Team' ? ['Team Members'] : ['Reviewers', 'Self'];
    if (reportType === 'Comparison') {
      reviewerTypes.splice(1,0,'space')
    }
    const introText = () => {
      if (reportType === 'Team') {
        return "Here is a list of team competencies, ranked highest to lowest, based on the feedback from all reviewers. This will give an indication of the teams general strengths and developmental needs."
      } else if (reportType === 'Self') {
        return "Here is a list of your competencies, ranked highest to lowest, based on your self-review responses. This will give you an indication of your general strengths and developmental needs."
      } else if (reportType === 'Group') {
        return "Here is a list of the group’s competencies, ranked highest to lowest, based on the collective feedback across all individual reports. You can compare each rating against the collective ‘self-review’. This will give you an indication of the group’s general strengths and developmental needs."
      } else {
        return "Here is a list of your competencies, ranked highest to lowest, based on your feedback from all your reviewers. You can compare each rating against your own self-review. This will give you an indication of your general strengths and developmental needs."
      }
    }
    return (generateGraph && limits) && (
      <>
        {
          limits.map((limitsObj, i) => {
            const { lowerLimit, upperLimit } = limitsObj;
            return (
              <div key={i} className='bg-white page-break user-report__content'>
                <PageHeader
                  h2Class='mt4'
                  h2Text='Part 1: '
                  strong='Step 2'
                  h3Text={`Capabilities: ranked highest to lowest${i > 0 ? ' (continued)' : ''}`}
                  line={true}
                />

                {i === 0 && <p>{introText()}</p>}

                {(reportType === 'Comparison' && i === 0) && <ComparisonKey spacing={true} />}

                <div 
                  className={`bb b--light-gray m${reportType === 'Comparison' ? 'b' : 'v'}5`}
                  style={{ width: layoutMode === 'pdfRecalculate' ? '158mm' : ''}}
                >
                  {sortedAnswerKeys &&
                      sortedAnswerKeys.map((key, index) => {
                        let reviewerAnswer;
                        let previousReviewerAnswer;
                        if (reportType !== 'Self') {
                          reviewerAnswer = +reviewerAnswersAverage[key]
                          if (reportType === 'Comparison') {
                            previousReviewerAnswer = +previousReviewerAverages[key]
                          }
                        }

                        if (index >= lowerLimit && index < upperLimit) {
                          return (
                            <div 
                              key={key}
                              ref={(sectionRow) => {
                                this[`competencyRow-${key}`] = sectionRow
                              }}
                              className='w-100 flex bt b--light-gray'
                            >
                              <RowTitle containerClass={`w-${reportType === 'Self' ? '5' : '4'}0 pr2`} title={sectionDetails[key].title} />
                      
                              {reportType !== 'Self' && (
                                <ReviewerTypeKeys reviewerTypes={reviewerTypes} userColour={userColour} reviewerColour={reviewerColour} />
                              )}
                              
                              <HorizontalBars 
                                reportType={reportType} 
                                containerClass={`w-${reportType === 'Self' ? '5' : '4'}0`}
                                pClass='flex' 
                                selfAnswerScore={revieweeAnswersAverage && revieweeAnswersAverage[key].toFixed(1)}
                                previousRevieweeAverages={previousRevieweeAverages && previousRevieweeAverages[key].toFixed(1)}
                                reviewersAnswerScore={reviewerAnswer && reviewerAnswer.toFixed(1)} 
                                previousReviewerAverages={previousReviewerAnswer && previousReviewerAnswer.toFixed(1)}
                                userColour={userColour} 
                                reviewerColour={reviewerColour} 
                              />
                            </div>
                          );
                        }
                      })
                  }
                </div>
              </div>
            )
          })
        }
        {(reportType !== 'Team') && (reportType !== 'Group') && (
          <Reflection step='2' subTitle='Capabilities: ranked highest to lowest' />
        )}
      </>
      
    )
  }
}
